import React, { FC, useEffect, useState } from 'react';
import MainHeader from '../../components/Main/Header/MainHeader';
import ModalWorkplace from '../../components/Main/Modals/ModalSelectWorkplace/ModalWorkplace';

import MainRoutes from '../../components/Routes/MainRoutes';
import styles from './MainLayout.module.scss';
import { useGetWorkplacesList } from '../../hooks/MainLayout/useGetWokplacesList';
import { getOperatorQueueName } from '../../constants/HeadersAPI';

type MainLayoutProps = {
  setIsAuthenticated: (status: boolean) => void;
};

const MainLayout: FC<MainLayoutProps> = ({ setIsAuthenticated }) => {
  const [activeModal, setActiveModal] = useState(true);
  const [isWorkPlaceSelected, setWorkPlaceSelected] = useState(false);
  const [workplaceName, setWorkplaceName] = useState<string | null>(() => {
    const raw = localStorage.getItem('workplace');
    if (!raw) return null;
    try {
      return (JSON.parse(raw)?.name as string | undefined) ?? null;
    } catch {
      return null;
    }
  });
  const [workplaceDescription, setWorkplaceDescription] = useState<string | null>(() => {
    const raw = localStorage.getItem('workplace');
    if (!raw) return null;
    try {
      return (JSON.parse(raw)?.description as string | undefined) ?? null;
    } catch {
      return null;
    }
  });

  // Backward compatibility: если раньше сохранили только id/label, подтягиваем description с бэка
  const queueNameFromUrl = getOperatorQueueName();
  const { userWorkplacesResp } = useGetWorkplacesList(queueNameFromUrl);

  useEffect(() => {
    if (workplaceName && workplaceDescription) return;
    const raw = localStorage.getItem('workplace');
    if (!raw) return;
    let id: number | null = null;
    try {
      id = (JSON.parse(raw)?.id as number | undefined) ?? null;
    } catch {
      id = null;
    }
    if (!id || !userWorkplacesResp?.length) return;

    const match = userWorkplacesResp.find((w: any) => w?.value === id);
    const resolvedName = String(match?.serviceUnitName ?? '').trim() || null;
    const resolvedDescription = String(match?.description ?? '').trim() || null;
    if (!resolvedName && !resolvedDescription) return;

    localStorage.setItem(
      'workplace',
      JSON.stringify({
        id,
        name: resolvedName,
        description: resolvedDescription,
        label: match?.label ?? null
      })
    );
    if (!workplaceName) setWorkplaceName(resolvedName);
    if (!workplaceDescription) setWorkplaceDescription(resolvedDescription);
  }, [workplaceName, workplaceDescription, userWorkplacesResp]);
  return (
    <div className={styles.mainContainer}>
      <MainHeader
        setIsAuthenticated={setIsAuthenticated}
        setWorkPlaceSelected={setWorkPlaceSelected}
        workplaceName={workplaceName}
        workplaceDescription={workplaceDescription}
        setWorkplaceName={setWorkplaceName}
        setWorkplaceDescription={setWorkplaceDescription}
      />
      <MainRoutes isWorkPlaceSelected={isWorkPlaceSelected} />
      <ModalWorkplace
        isActive={activeModal}
        setActiveModal={setActiveModal}
        setWorkPlaceSelected={setWorkPlaceSelected}
        setIsAuthenticated={setIsAuthenticated}
        setWorkplaceName={setWorkplaceName}
        setWorkplaceDescription={setWorkplaceDescription}
      />
    </div>
  );
};

export default MainLayout;
